import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/img7.jpg")